module.exports = __webpack_public_path__ + "static/media/UN-11.a33f8627.jpg";